export const detectPageType = (routeName) => {
  if (!routeName) return 'other'

  const name = routeName.toLowerCase()

  if (name.includes('index')) return 'home'
  if (name.includes('search')) return 'searchresults'
  if (name.includes('all')) return 'category'
  if (name.includes('product')) return 'product'
  if (name.includes('checkout-finished')) return 'purchase'
  if (name.includes('checkout')) return 'cart'

  return 'other'
}

export const getPageType = (context = null) => {
  const routeName = context?.$route?.name || (typeof window !== 'undefined' && window?.$nuxt?.$route?.name)
  return detectPageType(routeName)
}
